import { useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router"
import { RootState } from "../../../App/store"
import { useEffect } from "react"
import { RoleType, StorageKey } from "../../../App/enums"
import SessionService from "../../../App/SessionService"

function RoomEventDirectLink() {
    const role = useSelector((state: RootState) => state.rolesSlice.RolesSlice.roles)
    const params = useParams()
    const navigate = useNavigate()


    useEffect(() => {
        switch (role){
            case RoleType.ORGANIZATION:
                const orgId = SessionService.getItem(StorageKey.organizationId)
                if(orgId){
                    navigate('/room/'+ orgId + '/' +params['room_id']+ '?tab=events&event='+params['event_id'])
                }                
                break
            case RoleType.USER:
                navigate('/room/'+params['room_id']+ '?tab=events&event='+params['event_id'])
                break
            default:
                break
        }
    },[])

    return (
        <></>
    )
}

export default RoomEventDirectLink
